import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListNumbers12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconListNumbers12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ListNumbers12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M3.007-.007v4.541a.5.5 0 0 1-1 0V1.259l-.721.172a.5.5 0 0 1-.232-.973L2.391.14zm-.533 7.632c-.375 0-.663.242-.799.461a.5.5 0 1 1-.85-.525c.258-.42.829-.936 1.65-.936.34 0 .699.113.975.385.28.276.427.667.427 1.127 0 .798-.385 1.567-.831 2.198a8 8 0 0 1-.578.72h1.327a.5.5 0 1 1 0 1H1.25a.5.5 0 0 1-.33-.877 8.5 8.5 0 0 0 1.31-1.42c.4-.567.647-1.128.647-1.62 0-.245-.073-.36-.128-.415a.38.38 0 0 0-.275-.098M11.932 1.5a.5.5 0 0 1-.5.5H6.598a.5.5 0 0 1 0-1h4.834a.5.5 0 0 1 .5.5m-1.116 3a.5.5 0 0 1-.5.5H6.598a.5.5 0 1 1 0-1h3.718a.5.5 0 0 1 .5.5m.616 3.5a.5.5 0 0 0 0-1H6.598a.5.5 0 1 0 0 1zm-.616 2.5a.5.5 0 0 1-.5.5H6.598a.5.5 0 0 1 0-1h3.718a.5.5 0 0 1 .5.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ListNumbers12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconListNumbers12);
